import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import {BehaviorSubject, Observable} from 'rxjs';
import {retry, tap} from 'rxjs/operators';
import {FusionAuthService} from '../../../shared/services/fusion-auth';
import {UrlProviderService} from '../../../shared/services/general';
import {SECURED_STORE} from '../../../shared/utils';
import {TreeTest} from '../models/order-entry/test';
//import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class TestService {
  constructor(
    private urlProvider: UrlProviderService,
    private router: Router,
    private httpClient: HttpClient,
    private fusionAuthService: FusionAuthService,
  ) {
    this.treeBuilder = this.treeBuilder.bind(this);
  }

  public advancedSearchStore(dataSource: BehaviorSubject<DataSource>, role: string, clientIds: number[]) {
    return SECURED_STORE({
      dataSource,
      loadUrl: `${this.urlProvider.ApiUrl}/v2/tests/advanced-search`,
      routerService: this.router,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT(),
      key: 'key',
      loadParams: {
        role,
        clientIds
      }
    });
  }

  public customStore(dataSource: BehaviorSubject<DataSource>, clientId: number, allTest: boolean = false, clientsIds: number[] = []): CustomStore {
    let url = `/v2/tests/remote-operations?clientId=${clientId}&allTests=${allTest}`;

    if (clientsIds && clientsIds.length > 0) {
      url += `?`;
      const clientIdsArray: string[] = [];
      clientsIds.map(x => {
        clientIdsArray.push(`clientIds=${x}`);
      });
      url += clientIdsArray.join('&');
    }

    return SECURED_STORE({
      loadUrl: `${this.urlProvider.ApiUrl}${url}`,
      routerService: this.router,
      dataSource,
      loadParams: null,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT(),
    });
  }

  public readonly treeBuilder = (tests: TreeTest[]) => {
    try {
      for (const test of tests) {
        const index = tests.findIndex(t => t.children.findIndex(c => c.childId === test.id) !== -1);
        if (index !== -1) {
          const childIndex = tests[index].children.findIndex(c => c.childId === test.id);
          if (childIndex !== -1) {
            test.parentId = tests[index].children[childIndex].parentId
              ? tests[index].children[childIndex].parentId
              : tests[index].children[childIndex].ownerId;
          }
        }
      }
    } catch (e) {
      //Sentry.captureException(e);
    }
  }

  public treeCustomStore(dataSource: BehaviorSubject<DataSource>, clientId: number, allTest: boolean = false): CustomStore {
    return SECURED_STORE({
      loadUrl: `${this.urlProvider.ApiUrl}/v2/tests/remote-operations?clientId=${clientId}&allTests=${allTest}`,
      routerService: this.router,
      dataSource,
      loadParams: null,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT(),
      onLoaded: this.treeBuilder
    });
  }

  public getTestWithChildren(testIds: number[]): Observable<TreeTest[]> {
    let url = `/v2/tests/with-children?`;

    const testIdsArray: string[] = [];
    testIds.map(x => {
      testIdsArray.push(`testId=${x}`);
    });

    if (testIdsArray.length > 0) {
      url += testIdsArray.join('&');
    }

    return this.httpClient.get<TreeTest[]>(`${this.urlProvider.ApiUrl}${url}`)
      .pipe(
        tap(this.treeBuilder),
        retry(2)
      );
  }

  public getIdsTestWithChildren(testIds: number[]): Observable<number[]> {
    let url = `/v2/tests/ids-with-children?`;

    const testIdsArray: string[] = [];
    testIds.map(x => {
      testIdsArray.push(`testId=${x}`);
    });

    if (testIdsArray.length > 0) {
      url += testIdsArray.join('&');
    }

    return this.httpClient.get<number[]>(`${this.urlProvider.ApiUrl}${url}`)
      .pipe(retry(2));
  }
}
